import fetch from "lib/fetch";

type LanguageResponse = { data: HashMap<string> };

export const getTranslationsRequest = (languageCode: string) =>
    fetch.get<LanguageResponse>(`language/all/${languageCode}`);
